var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',[_c(_setup.ContactNav),_vm._v(" "),_c(_setup.ContactHeader),_vm._v(" "),_c(_setup.ContactForm),_vm._v(" "),_c(_setup.LandsideFooterOld)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }